module.exports = {"500153001":"昌元街道","500153002":"昌州街道","500153003":"广顺街道","500153004":"双河街道","500153005":"安富街道","500153006":"峰高街道","500153100":"荣隆镇","500153101":"仁义镇","500153102":"盘龙镇","500153103":"吴家镇","500153104":"直升镇","500153105":"万灵镇","500153106":"清升镇","500153107":"清江镇","500153108":"古昌镇","500153109":"河包镇","500153110":"观胜镇","500153111":"铜鼓镇","500153112":"清流镇","500153113":"远觉镇","500153114":"龙集镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500153.json
// module id = 2234
// module chunks = 0